import { REPORTS, REPORTS_PERFORMANCE } from '@/routes/report'

import PassThroughView from '@/views/general/PassThroughView'

const ReportPerformanceView = () => import(/* webpackChunkName: "report" */'@/views/report/ReportPerformanceView')

export default [
  {
    path: '/reports',
    component: PassThroughView,
    meta: {
      titleKey: 'report.title',
      root: REPORTS,
      mainRoutes: [ REPORTS_PERFORMANCE ]
    },
    children: [
      {
        path: '',
        component: ReportPerformanceView,
        name: REPORTS_PERFORMANCE,
        meta: {
          titleKey: 'reportPerformance.title'
        }
      }
    ]
  }
]
